"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MortgageExceedTenorError = exports.MortgageTooMuchLoanAmountError = exports.MortgageTooMuchLoanPercentError = exports.MortgageCommonError = void 0;
var MortgageCommonError = /** @class */ (function () {
    function MortgageCommonError() {
    }
    return MortgageCommonError;
}());
exports.MortgageCommonError = MortgageCommonError;
var MortgageTooMuchLoanPercentError = /** @class */ (function (_super) {
    __extends(MortgageTooMuchLoanPercentError, _super);
    function MortgageTooMuchLoanPercentError(n) {
        var _this = _super.call(this) || this;
        _this.maxLoanPercent = n;
        return _this;
    }
    return MortgageTooMuchLoanPercentError;
}(MortgageCommonError));
exports.MortgageTooMuchLoanPercentError = MortgageTooMuchLoanPercentError;
var MortgageTooMuchLoanAmountError = /** @class */ (function (_super) {
    __extends(MortgageTooMuchLoanAmountError, _super);
    function MortgageTooMuchLoanAmountError(n) {
        var _this = _super.call(this) || this;
        _this.maxLoanAmount = n;
        return _this;
    }
    return MortgageTooMuchLoanAmountError;
}(MortgageCommonError));
exports.MortgageTooMuchLoanAmountError = MortgageTooMuchLoanAmountError;
var MortgageExceedTenorError = /** @class */ (function (_super) {
    __extends(MortgageExceedTenorError, _super);
    function MortgageExceedTenorError(n) {
        var _this = _super.call(this) || this;
        _this.maxTenor = n;
        return _this;
    }
    return MortgageExceedTenorError;
}(MortgageCommonError));
exports.MortgageExceedTenorError = MortgageExceedTenorError;
